import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const lang = localStorage.getItem("guangdong_lan_locale") || "zh";
    if (config.method == 'get') {
      const params = config.params || {}
      params.lang = lang;
      config.params = params
    }
    return config
  },
  error => {
    return {
      code: -1,
      msg: error.message
    }
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    // 返回码不等于0表示请求有异常
    // if (res.code !== 0) {
    //   if (response.status == '200') {
    //     Message({
    //       message: res.msg || 'Error',
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //   }
    // }
    return res
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return {
      code: -1,
      msg: error.message
    }
  }
)

export default service
